/* eslint-disable prefer-destructuring */
import styled, { type DefaultTheme, css } from "styled-components";
import { theme as toyotaTheme } from "../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../common-deprecated/themes/common";
import * as NavigationStepStyles from "./NavigationStepStyles";

export const NAV_BAR_HEIGHT = 56; // height of our own bar (desktop & mobile)

type StickyWrapperProps = {
    showBorder?: boolean;
    zIndexName?: NonNullable<keyof DefaultTheme["zIndex"]>;
    disabled?: boolean;
};

export const StickyWrapper = styled.div<StickyWrapperProps>`
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    min-height: 50px;
    background: ${toyotaTheme.colors.primaryWhite};
    /* Transition of top should match GFIs implementation */
    transition:
        border-bottom-color 0.3s,
        top 0.3s ease-out;
    z-index: ${toyotaTheme.zIndex.fixed};

    ${({ disabled }) =>
        !disabled &&
        css`
            position: sticky;
            top: var(--visibleHeaderHeight, 0);
        `}

    /* Follows GFI breakpoints */
    @media (min-width: 768px) and (max-width: 991px) {
        z-index: ${toyotaTheme.zIndex.overlay};
    }
`;

export const NavHeader = styled.div`
    padding: ${toyotaTheme.space[2]}px ${toyotaTheme.space[2]}px ${toyotaTheme.space[3]}px ${toyotaTheme.space[3]}px;
    @media ${getBreakpoint("up", "lg")} {
        text-align: center;
    }
`;

export const DesktopNav = styled.div<{ insideModal?: boolean }>`
    @media ${getBreakpoint("down", "lg")} {
        display: none;
    }

    ${NavigationStepStyles.Wrapper} {
        flex-direction: row;
        justify-content: center;
        padding: 15px ${({ insideModal }) => (insideModal ? "15px" : "0")};
        @media ${getBreakpoint("up", "lg")} {
            padding-bottom: ${toyotaTheme.space[4]}px;
        }
    }
`;

export const MobileNav = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${toyotaTheme.colors.grey2};
    @media ${getBreakpoint("up", "lg")} {
        display: none;
    }

    ${NavigationStepStyles.Wrapper} {
        flex-direction: column;
        padding: 25px 0;

        ${NavigationStepStyles.Step} {
            margin: 10px 0;
            padding-left: 0;
            padding-right: 0;
        }
    }
`;

export const MobileNavHeader = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: ${NAV_BAR_HEIGHT}px;
    padding: 0;
    background: transparent;
`;

export const MobileNavButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-left: ${toyotaTheme.space[2]}px;
    padding-right: ${toyotaTheme.space[2]}px;
    .icon {
        top: 2px;
        margin-left: -${toyotaTheme.space[1]}px;
        &::before {
            font-size: 1.2rem;
        }
    }
    ${NavigationStepStyles.Step} {
        align-items: center;
        font-family: ${toyotaTheme.fonts.regular};
    }
`;

export const BasketTitle = styled.h2`
    margin: 0;
    padding-top: ${toyotaTheme.space[2]}px;
    padding-bottom: ${toyotaTheme.space[3]}px;
    font-family: ${toyotaTheme.fonts.regular};
    font-size: 2rem;
    line-height: 2.4rem;
    text-transform: none;
    color: ${toyotaTheme.colors.primaryWhite};
`;

export const Badge = styled.div`
    margin: 0 8px;
    font-size: 1.4rem;
    color: ${toyotaTheme.colors.primaryRed};
`;

export const FloatingNav = styled.div<{ visible: boolean }>`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    padding: 0 ${({ theme }) => theme.space[3]}px;
    background-color: ${toyotaTheme.colors.primaryWhite};
    border-radius: 0px 0px 4px 4px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    opacity: ${(props) => (props.visible ? 1 : 0)};
    pointer-events: ${(props) => (props.visible ? "initial" : "none")};
`;

export const PriceOverview = styled.div``;

export const PriceOverviewSmall = styled.div`
    font-size: 1.3rem;
    line-height: 2rem;
`;

export const PriceOverviewLarge = styled.div`
    font-family: ${toyotaTheme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
`;
